<!--
  Angular 15: *ngIf / *ngFor only, no @if blocks.
-->
<div class="dl-page dl-page--narrow">

  <div class="dl-page__heading">
    <a class="dl-page__back" routerLink="/catalogs">
      <mat-icon>chevron_left</mat-icon>
      Catalogs
    </a>
    <h1 class="dl-page__title">Manufacturers</h1>
    <p class="dl-page__subtitle">
      The global list of brands that catalogs refer to. A rename applies everywhere the manufacturer is used.
    </p>
  </div>

  <div class="dl-card">
    <div class="dl-card__body">
      <form class="mf-add" (ngSubmit)="add()">
        <div class="dl-field mf-add__field">
          <label class="dl-field__label" for="mfNew">New manufacturer</label>
          <input id="mfNew" name="newName" class="dl-input" [(ngModel)]="newName" maxlength="120"
                 autocomplete="off" [disabled]="adding" data-testid="manufacturer-new-name" />
        </div>
        <button type="submit" class="dl-btn dl-btn--primary" [disabled]="!newName.trim() || adding"
                data-testid="manufacturer-add">
          <mat-icon>add</mat-icon>
          {{ adding ? 'Adding…' : 'Add' }}
        </button>
      </form>
      <div class="dl-banner dl-banner--error mf-banner" *ngIf="addError">
        <mat-icon>error</mat-icon>
        <div class="dl-banner__body">{{ addError }}</div>
      </div>
    </div>
  </div>

  <div class="dl-loading" *ngIf="loading">
    <div class="dl-spinner"></div>
    <p>Loading…</p>
  </div>

  <div class="dl-banner dl-banner--error" *ngIf="error">
    <mat-icon>error</mat-icon>
    <div class="dl-banner__body">{{ error }}</div>
    <div class="dl-banner__actions">
      <button type="button" class="dl-btn dl-btn--sm" (click)="load()">Try again</button>
    </div>
  </div>

  <div class="dl-card" *ngIf="!loading && !error">
    <div class="dl-card__header">
      <h2 class="dl-card__title">All manufacturers</h2>
      <span class="dl-card__subtitle">{{ filtered.length }} of {{ manufacturers.length }}</span>
    </div>
    <div class="dl-card__body mf-search">
      <input type="text" class="dl-input" [(ngModel)]="search" placeholder="Search by name"
             aria-label="Search by name" data-testid="manufacturer-search" />
    </div>

    <div class="dl-banner dl-banner--error mf-banner mf-banner--inset" *ngIf="editError">
      <mat-icon>error</mat-icon>
      <div class="dl-banner__body">{{ editError }}</div>
    </div>

    <app-empty-state icon="factory" title="No manufacturers" *ngIf="filtered.length === 0">
      <ng-container *ngIf="search; else noneYet">Nothing matches the search.</ng-container>
      <ng-template #noneYet>Add the first one above.</ng-template>
    </app-empty-state>

    <table class="dl-table dl-table--cards" dlCardTable *ngIf="filtered.length > 0" data-testid="manufacturers-table">
      <thead>
        <tr>
          <th>Name</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let m of filtered; trackBy: trackById" [attr.data-testid]="'manufacturer-row-' + m.id">
          <ng-container *ngIf="editingId === m.id; else readRow">
            <td class="dl-cell--title">
              <input class="dl-input" [(ngModel)]="editName" maxlength="120" aria-label="Name"
                     (keydown.enter)="saveEdit(m)" (keydown.escape)="cancelEdit()"
                     [disabled]="saving" data-testid="manufacturer-edit-name" />
            </td>
            <td class="dl-cell--bare mf-actions">
              <button type="button" class="dl-btn dl-btn--sm" (click)="cancelEdit()" [disabled]="saving">Cancel</button>
              <button type="button" class="dl-btn dl-btn--sm dl-btn--primary" (click)="saveEdit(m)"
                      [disabled]="!editName.trim() || saving" data-testid="manufacturer-save">
                {{ saving ? 'Saving…' : 'Save' }}
              </button>
            </td>
          </ng-container>
          <ng-template #readRow>
            <td class="dl-cell--title">{{ m.name }}</td>
            <td class="dl-cell--bare mf-actions">
              <button type="button" class="dl-btn dl-btn--ghost dl-btn--icon" (click)="startEdit(m)"
                      [disabled]="editingId !== null" matTooltip="Rename" aria-label="Rename"
                      data-testid="manufacturer-rename">
                <mat-icon>edit</mat-icon>
              </button>
            </td>
          </ng-template>
        </tr>
      </tbody>
    </table>
  </div>
</div>
